import stepComponents from './stepComponents'

const supplierInvite = {
  stepComponents,
}

export default supplierInvite
